import React, { useEffect } from 'react';
import { FilterProvider, useFilters } from './context/FilterContext';
import { BoardProvider, useBoardState, useBoardActions } from './context/BoardContext';
import ErrorFallback from 'components/ErrorFallback/ErrorFallback';
import BoardContent from './components/BoardContent';
import { SpinnerComponent } from 'shared/SpinnerComponent';
import { clearDescriptionsCache } from './hooks/useLeadDescription';
import { setAppTitle } from 'utils/utils';

const BoardWrapper = () => {
  const { initialLoading, error } = useBoardState();
  const { resetBoard } = useBoardActions();

  if (initialLoading) {
    return <SpinnerComponent />;
  }

  if (error) {
    return <ErrorFallback resetErrorBoundary={resetBoard} />;
  }

  return <BoardContent />;
};

const BoardWithFilters = () => {
  const filters = useFilters();

  // Build filter object for API
  const filterParams = {
    searchKeyword: filters.searchKeyword,
    practiceArea: filters.practiceArea,
    assignedTo: filters.assignedTo,
    sortType: filters.sortType,
  };

  return (
    <BoardProvider filters={filterParams}>
      <BoardWrapper />
    </BoardProvider>
  );
};

const LeadBoard = () => {
  useEffect(() => {
    setAppTitle('Leads');
    return () => {
      setAppTitle();
      clearDescriptionsCache();
    };
  }, []);

  return (
    <FilterProvider>
      <BoardWithFilters />
    </FilterProvider>
  );
};

export default LeadBoard;
